/*
  import { budgetStore } from '@/services/Budgets/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'

import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await budgetStore.dispatch ('getBudgetList', {
      hoaId
    });
  */

  //Fical year periods List
  async getPeriodsByFiscalYear({}, { hoaID, fiscalYear }) {
    try {
      const params = {
        hoaID: hoaID,
        year: fiscalYear
      }

      const results = await kms.get(
        '/GeneralAccounting/FiscalYear/AccountingPeriodsForFiscalYear',
        { params }
      )

      if (isDebug == true) console.debug('getPeriodsByFiscalYear=' + JSON.stringify(results))

      return {
        list: results
      }
    } catch (exception) {
      notifyProblem(`The Periods By Fiscal Year list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  //Fical year periods List
  async getCurrentEffectiveBudget({}, { hoaID }) {
    try {
      const params = {
        hoaID: hoaID
      }

      const results = await kms.get('/Budgets/Budget/GetEffectiveBudgetByDate', { params })

      if (isDebug == true) console.debug('getCurrentEffectiveBudget=' + JSON.stringify(results))

      return {
        list: results
      }
    } catch (exception) {
      console.debug(`The CurrentEffectiveBudget could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async runBudgetSummaryBase64Report({}, { params }) {
    console.log('in runBudgetSummaryBase64Report...')
    try {
      const result = await kms.get(
        `/Budgets/Reports/BudgetSummaryReport/GetAsBaseSixtyFour?hoaID=${params.hoaID}&budgetID=${params.budgetID}&format=${params.format}`
      )

      if (isDebug == true)
        console.debug('runBudgetSummaryBase64Report log=' + JSON.stringify(result))

      return {
        returned: result
      }
    } catch (exception) {
      notifyProblem(`The budget summary report could not be retrieved.`)
      console.error(exception)
    }

    return {
      returned: ''
    }
  },

  async runBudgetDetailBase64Report({}, { params }) {
    console.log('in runBudgetDetailBase64Report...')
    try {
      const result = await kms.get(
        `/Budgets/Reports/BudgetDetailReport/GetAsBaseSixtyFour?hoaID=${params.hoaID}&budgetID=${params.budgetID}&format=${params.format}`
      )

      if (isDebug == true)
        console.debug('runBudgetDetailBase64Report log=' + JSON.stringify(result))

      return {
        returned: result
      }
    } catch (exception) {
      notifyProblem(`The budget detail report could not be retrieved.`)
      console.error(exception)
    }

    return {
      returned: ''
    }
  },

  //Budget Amount List
  async getBudgetAmountsList({}, { hoaID, budgetAccountID }) {
    try {
      const params = {
        hoaID: hoaID,
        budgetAccountID: budgetAccountID
      }

      const returned = await kms.get('/Budgets/BudgetAmount/ListWithTotals', { params })

      const totals = {
        totalAmountBudgeted: returned.totalAmountBudgeted,
        totalLastActuals: returned.totalLastActuals,
        totalLastBudgeted: returned.totalLastBudgeted
      }

      let results = { budgetAmountTotals: totals, budgetAmountsList: returned }

      if (isDebug == true) console.debug('getBudgetAmountsList=' + JSON.stringify(results))

      return {
        list2: results
      }
    } catch (exception) {
      notifyProblem(`The Budget Amount list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list2: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const budgetStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
